import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';

type LocalazyKeyUrlQuery = operations['localazyKeyURLOP']['parameters']['query'];

async function fetchLocalazyKeyUrl(apiClient: ApiClient, query: LocalazyKeyUrlQuery) {
  return apiClient.GET('/op/v2/localazy/key-url', {
    params: {
      query,
    },
  });
}

export function useLocalazyKeyUrlMutation(locale: string) {
  const apiClient = useApiClient();

  return useMutation<InferFetchData<typeof fetchLocalazyKeyUrl>, ApiError, { search: string }>({
    mutationKey: ['LocalazyKeyUrl', locale],
    mutationFn: async ({ search }) =>
      throwOnError(
        fetchLocalazyKeyUrl(apiClient, {
          search,
          locale,
        }),
      ),
  });
}
